export const billingGroupsKeys = {
  all: ['billing-groups'] as const,
  lists: () => [...billingGroupsKeys.all, 'list'] as const,
  list: (page: number, perPage: number) =>
    [...billingGroupsKeys.lists(), { page, perPage }] as const,
  details: () => [...billingGroupsKeys.all, 'detail'] as const,
  detail: (id: number) => [...billingGroupsKeys.details(), { id }] as const,
};
